export const CommonConstant = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL + "api/",
  LOGIN_URL: process.env.REACT_APP_API_BASE_LOGIN_URL,
  LEGACY_URL: process.env.REACT_APP_LEGACY_URL,
  SEARCH_ORDERS: process.env.REACT_APP_API_BASE_URL + "api/Visit/SearchOrders?",
  SCRIPTINGAGTR_URL: process.env.REACT_APP_SCRIPTINGAGTR_URL,
};

export const APIData = (data = [], loading = false, called = false) => ({
  data,
  called,
  loading
});
